import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/section/styles.scss';export default {
  "header": "_header_bevhn_1",
  "iconBox": "_iconBox_bevhn_10",
  "icon": "_icon_bevhn_10",
  "open": "_open_bevhn_28"
};